__turbopack_context__.v({
  "actions": "_2wxTGq_actions",
  "textWrapper": "_2wxTGq_textWrapper",
  "wrapper": "_2wxTGq_wrapper",
});
